module.exports = __webpack_public_path__ + "static/media/11-mercedes.ead540eb.jpg";